import _ from 'lodash';

const getEmailRecipientsFromString = (str) => {
  const arr = (str || '').split(',');
  return _.map(arr, (e) => e.trim());
};
export default getEmailRecipientsFromString;
